import styled from 'styled-components';

export const InputStyled = styled.input`
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
  height: 38px;
  box-sizing: border-box;
  display: block;
  padding: 0 16px;
  width: 100%;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  font-family: inherit;
  font-size: 14px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &[type=checkbox] {
    width: 20px;
    height: 20px;
    accent-color: var(--color-primary);
    cursor: pointer;
  }

  &::placeholder {
    color: var(--text-muted);
  }

  &:hover:not(:focus):not(:disabled) {
    border-color: var(--border-color-hover);
    background: rgba(255, 255, 255, 0.05);
  }

  &:focus {
    outline: 0;
    border-color: var(--color-primary);
    background: rgba(9, 9, 11, 0.4);
    box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.15);
  }

  &:disabled {
    outline: 0;
    background: rgba(255, 255, 255, 0.01);
    border-color: var(--border-color);
    color: var(--text-muted);
    cursor: not-allowed;
  }

  &.invalid, &:invalid {
    
  }
`;